<template>
  <GridContainer>
    <GridRow align-h="center">
      <GridColumn :md="8">
        <Heading
          tag="h2"
          size="lg"
          text-uppercase
          align="center"
          class="google-faq__heading"
          >Fragen & Antworten</Heading
        >
        <AccordionItem
          v-for="(faq, key) in faqs"
          :key="key"
        >
          <Heading
            slot="title"
            tag="h3"
          >
            {{ faq.title }}
          </Heading>
          <Paragraph slot="content">
            {{ faq.content }}
          </Paragraph>
        </AccordionItem>
      </GridColumn>
    </GridRow>
  </GridContainer>
</template>

<script>
import {
  AccordionItem,
  GridContainer,
  GridRow,
  GridColumn,
  Heading,
  Paragraph,
} from '@i22-td-smarthome/component-library';

export default {
  title: 'GoogleFaq',
  components: {
    AccordionItem,
    GridContainer,
    GridRow,
    GridColumn,
    Heading,
    Paragraph,
  },
  props: {
    faqs: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss" scoped>
.google-faq {
  &__heading {
    margin-bottom: 1.125rem;
  }
}
</style>
